import { gql } from '@apollo/client';
import withStyles from 'isomorphic-style-loader/withStyles';
import { flowRight as compose } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import cx from 'classnames';
import { injectIntl } from 'react-intl';
import { withQuery } from '../../hoc/withGraphql';
import s from './Feedback.css';
import fondoOndulado from '/public/SiteImages/fondo-ondulado-para-personaje.svg';
import monedaIcon from '/public/SiteImages/personaje-10-bolivianos.svg';
import celularIcon from '/public/SiteImages/personaje-celular.svg';
import maletaIcon from '/public/SiteImages/personaje-maleta.svg';
import verifiedIcon from '/public/SiteImages/personaje-pago-seguro.svg';

const Feedback = ({ data: { loading } = {}, hideTitle = false }) => {
  if (loading) return <div />;

  return (
    <div
      className={cx(s.root, 'commonWordBreak')}
      style={{ backgroundImage: `url(${fondoOndulado})` }}
    >
      <div className={s.container}>
        {!hideTitle && (
          <div className={s.titleWrapper}>
            <h3 className={s.sectionTitle}>
              ¿Qué nos <span className={s.highlight}>diferencia</span> de otras plataformas?
            </h3>
          </div>
        )}
        <div className={s.feedbackContainer}>
          <div className={cx(s.feedbackRow)}>
            <div className={cx(s.feedbackBox, s.cardVerificados)}>
              <div className={s.flex}>
                <div className={cx(s.iconWrapper, s.iconVerificados)}>
                  <img src={verifiedIcon} className={s.homeIcon} alt="Alojamientos verificados" />
                </div>
                <label className={cx(s.landingLabel)}>
                  Alojamientos {/* <br className="hidden-xs" />  */}verificados
                </label>
              </div>
              <div className={cx(s.feedbackContent)}>
                <label className={cx(s.landingCaption)}>
                  Cada propiedad pasa por una revisión antes de publicarse.
                </label>
              </div>
            </div>

            <div className={cx(s.feedbackBox, s.cardPagoQr)}>
              <div className={s.flex}>
                <div className={cx(s.iconWrapper, s.iconPagoQr)}>
                  <img src={celularIcon} className={s.celularIcon} alt="Paga con QR en bolivianos" />
                </div>
                <label className={cx(s.landingLabel)}>
                  Paga con QR en {/* <br className="hidden-xs" />  */}bolivianos
                </label>
              </div>
              <div className={cx(s.feedbackContent)}>
                <label className={cx(s.landingCaption)}>
                  No necesitas una tarjeta internacional. Paga directo desde tu app bancaria, en bolivianos.
                </label>
              </div>
            </div>

            <div className={cx(s.feedbackBox, s.cardPrecioClaro)}>
              <div className={s.flex}>
                <div className={cx(s.iconWrapper, s.iconPrecioClaro)}>
                  <img src={monedaIcon} className={s.monedaIcon} alt="Precio claro sin cargos ocultos" />
                </div>
                <label className={cx(s.landingLabel)}>
                  Precio claro sin {/* <br className="hidden-xs" />  */}cargos ocultos
                </label>
              </div>
              <div className={cx(s.feedbackContent)}>
                <label className={cx(s.landingCaption)}>
                  El precio que ves es el que pagas, sin cargos adicionales.
                </label>
              </div>
            </div>

            <div className={cx(s.feedbackBox, s.cardSoporte)}>
              <div className={s.flex}>
                <div className={cx(s.iconWrapper, s.iconSoporte)}>
                  <img src={maletaIcon} className={s.monedaIcon} alt="Soporte humano real 24/7" />
                </div>
                <label className={cx(s.landingLabel)}>
                  Soporte humano {/* <br className="hidden-xs" />  */}real 24/7
                </label>
              </div>
              <div className={cx(s.feedbackContent)}>
                <label className={cx(s.landingCaption)}>
                  Siempre hay un miembro de Eslipin disponible para ayudarte.
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Feedback.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool,
    getFooterSetting: PropTypes.shape({
      title1: PropTypes.string,
      content1: PropTypes.string,
      title2: PropTypes.string,
      content2: PropTypes.string,
      title3: PropTypes.string,
      content3: PropTypes.string,
    }),
  }),
  hideTitle: PropTypes.bool,
};

export default compose(
  injectIntl,
  withStyles(s),
  withQuery(gql`
    query getFooterSetting {
      getFooterSetting {
        id
        title1
        content1
        title2
        content2
        title3
        content3
      }
    }
  `, { options: { ssr: false } })
)(Feedback);
